// @ts-nocheck
import React from 'react';
import { motion } from 'framer-motion';

const HeroMockup = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40, rotateX: 10 }}
      animate={{ opacity: 1, y: 0, rotateX: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="relative w-full max-w-4xl mx-auto perspective-1000"
    >
      {/* Glow Effect */}
      <div className="absolute -inset-4 bg-gradient-to-r from-primary to-secondary opacity-20 blur-2xl rounded-[2rem] -z-10"></div>

      {/* Main Frame */}
      <div className="relative bg-slate-100 rounded-2xl border border-slate-200 shadow-2xl overflow-hidden">
        {/* Browser Header */}
        <div className="h-9 bg-slate-200/90 border-b border-slate-200 flex items-center px-4 gap-2">
          <div className="w-3 h-3 rounded-full bg-red-500/80" />
          <div className="w-3 h-3 rounded-full bg-yellow-500/80" />
          <div className="w-3 h-3 rounded-full bg-green-500/80" />
          <div className="ml-4 flex-1 h-4 bg-slate-50 rounded-full max-w-[220px]" />
        </div>

        {/* App Mockup */}
        <div className="relative flex flex-col md:flex-row aspect-[4/3] md:aspect-[16/9] w-full bg-slate-50">
          {/* Sidebar */}
          <div className="w-full md:w-60 bg-gradient-to-b from-slate-100 to-slate-50 md:border-r border-slate-200 p-4 space-y-4">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-xl bg-primary/30 flex items-center justify-center text-primary text-lg font-bold">
                a
              </div>
              <div>
                <div className="text-xs uppercase tracking-[0.18em] text-violet-600/80">
                  Arrangelly
                </div>
                <div className="text-[10px] text-slate-500">Teaching Suite</div>
              </div>
            </div>

            <div className="space-y-1 text-[11px] font-medium text-slate-600">
              <div className="px-3 py-2 rounded-lg bg-violet-100 text-violet-900 flex items-center justify-between">
                <span className="uppercase tracking-[0.18em] text-[10px]">Overview</span>
                <span className="text-[9px] bg-primary/30 px-1.5 py-0.5 rounded-full text-primary-foreground/80">
                  LIVE
                </span>
              </div>
              <div className="px-3 py-2 rounded-lg hover:bg-slate-50 cursor-pointer flex justify-between">
                <span className="uppercase tracking-[0.18em]">Bookings</span>
                <span className="text-[10px] text-violet-600">24</span>
              </div>
              <div className="px-3 py-2 rounded-lg hover:bg-slate-50 cursor-pointer flex justify-between">
                <span className="uppercase tracking-[0.18em]">Students</span>
                <span className="text-[10px] text-violet-600">112</span>
              </div>
              <div className="px-3 py-2 rounded-lg hover:bg-slate-50 cursor-pointer flex justify-between">
                <span className="uppercase tracking-[0.18em]">Courses</span>
                <span className="text-[10px] text-violet-600">18</span>
              </div>
              <div className="px-3 py-2 rounded-lg hover:bg-slate-50 cursor-pointer flex justify-between">
                <span className="uppercase tracking-[0.18em]">AI Exercises</span>
                <span className="text-[10px] text-emerald-600">New</span>
              </div>
              <div className="px-3 py-2 rounded-lg hover:bg-slate-50 cursor-pointer flex justify-between">
                <span className="uppercase tracking-[0.18em]">Payments</span>
                <span className="text-[10px] text-emerald-600">€</span>
              </div>
              <div className="px-3 py-2 rounded-lg hover:bg-slate-50 cursor-pointer flex justify-between">
                <span className="uppercase tracking-[0.18em]">Calendar</span>
                <span className="text-[10px] text-violet-600">Today</span>
              </div>
            </div>

            <div className="hidden sm:block mt-4 border-t border-slate-200 pt-3 space-y-2">
              <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Integrations</div>
              <div className="flex items-center justify-between text-[11px] text-slate-600">
                <span>Payments</span>
                <span className="w-2 h-2 rounded-full bg-emerald-400" />
              </div>
              <div className="flex items-center justify-between text-[11px] text-slate-600">
                <span>Meetings</span>
                <span className="w-2 h-2 rounded-full bg-emerald-400" />
              </div>
              <div className="flex items-center justify-between text-[11px] text-slate-600">
                <span>Newsletter</span>
                <span className="w-2 h-2 rounded-full bg-emerald-400" />
              </div>
            </div>
          </div>

          {/* Main dashboard */}
          <div className="flex-1 p-4 md:p-5 space-y-4 bg-gradient-to-br from-slate-50 via-white to-violet-50/40">
            {/* Top row: stats */}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
              <div className="rounded-xl border border-slate-200 bg-slate-50 px-3 md:px-4 py-3">
                <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500 mb-1">
                  Monthly Revenue
                </div>
                <div className="flex items-baseline justify-start gap-2">
                  <span className="text-lg font-semibold text-foreground">€12,480</span>
                </div>
                <div className="mt-1 text-[10px] text-emerald-600">+18.4% vs last month</div>
              </div>
              <div className="rounded-xl border border-slate-200 bg-slate-50 px-3 md:px-4 py-3">
                <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500 mb-1">
                  Active Students
                </div>
                <div className="flex items-baseline justify-start gap-2">
                  <span className="text-lg font-semibold text-foreground">112</span>
                </div>
                <div className="mt-1 text-[10px] text-emerald-600">+9 new this week</div>
              </div>
              <div className="hidden md:block rounded-xl border border-slate-200 bg-slate-50 px-4 py-3">
                <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500 mb-1">
                  Upcoming Lessons
                </div>
                <div className="flex items-end justify-between">
                  <span className="text-lg font-semibold text-foreground">24</span>
                  <span className="text-[10px] text-violet-600">Next in 12 min</span>
                </div>
              </div>
            </div>

            {/* Bottom row: schedule + activity */}
            <div className="grid md:grid-cols-3 gap-4 h-full">
              <div className="md:col-span-2 rounded-xl border border-slate-200 bg-slate-50 p-4 flex flex-col">
                <div className="flex items-center justify-between mb-3">
                  <div>
                    <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500">
                      Today&apos;s Schedule
                    </div>
                    <div className="text-xs text-slate-500">Meeting links generated automatically</div>
                  </div>
                  <div className="text-[10px] text-slate-500">Friday</div>
                </div>
                <div className="space-y-2 text-[11px] text-slate-700">
                  <div className="flex items-center justify-between rounded-lg bg-white border border-slate-200 px-3 py-2">
                    <span className="text-slate-500 w-20">10:00</span>
                    <span className="flex-1">Piano – Beginner Group</span>
                    <span className="text-[10px] text-emerald-600">Payment confirmed</span>
                  </div>
                  <div className="flex items-center justify-between rounded-lg bg-white border border-slate-200 px-3 py-2">
                    <span className="text-slate-500 w-20">13:30</span>
                    <span className="flex-1">Guitar – 1:1 Lesson</span>
                    <span className="text-[10px] text-violet-600">Meeting link</span>
                  </div>
                  <div className="hidden sm:flex items-center justify-between rounded-lg bg-white border border-slate-200 px-3 py-2">
                    <span className="text-slate-500 w-20">18:00</span>
                    <span className="flex-1">Theory – Online Class</span>
                    <span className="text-[10px] text-amber-600">Waitlist 3</span>
                  </div>
                </div>
              </div>

              <div className="hidden md:flex rounded-xl border border-slate-200 bg-slate-50 p-4 flex-col">
                <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500 mb-2">Activity</div>
                <div className="space-y-2 text-[11px] text-slate-700 flex-1">
                  <div className="flex items-start gap-2">
                    <div className="mt-1 w-1 h-8 bg-gradient-to-b from-primary to-secondary rounded-full" />
                    <div>
                      <div className="text-xs text-foreground">New booking confirmed</div>
                      <div className="text-[10px] text-slate-500">Anna • Piano • Payments</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="mt-1 w-1 h-8 bg-emerald-500/80 rounded-full" />
                    <div>
                      <div className="text-xs text-foreground">Newsletter sent</div>
                      <div className="text-[10px] text-slate-500">124 recipients • 48% open</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Elements for 3D effect */}
      <motion.div
        animate={{ y: [0, -10, 0] }}
        transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
        className="absolute -right-8 top-20 bg-white/90 backdrop-blur-md border border-slate-200 p-4 rounded-lg shadow-xl hidden md:block"
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-accent/20 flex items-center justify-center text-accent">
            ♫
          </div>
          <div>
            <div className="h-2 w-20 bg-slate-200 rounded mb-2"></div>
            <div className="h-2 w-12 bg-slate-100 rounded"></div>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default HeroMockup;
